import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IUserProfile } from "../../../types/userTypes";
import { nullUserProfile } from "./user/blankUser";

type InitialState = {
  authStatus: boolean;
  userProfile: IUserProfile;
};

const initialState: InitialState = {
  authStatus: false,
  userProfile: nullUserProfile,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setAuthStatus: (state, action: PayloadAction<boolean>) => {
      state.authStatus = action.payload;
    },
    setUserProfile: (state, action: PayloadAction<IUserProfile>) => {
      state.userProfile = action.payload;
    },
  },
});

export const { setAuthStatus, setUserProfile } = userSlice.actions;
const userReducer = userSlice.reducer;
export default userReducer;
